import { i18n } from '@lingui/core';

export const defaultLocale = 'en';

export const locales = {
  en: 'English',
  de: 'Deutsch',
};

export async function activate(locale) {
  const catalog = await import(
    /* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */
    `../locales/${locale}.js`
  );
  await i18n.load(locale, catalog);
  return i18n.activate(locale);
}
